import React from 'react';
import { Checkbox } from '@blueprintjs/core';
import { ShowIf } from 'components/utils';

class CheckBox extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      checked: this.props.isChecked
    }
  }

  onChange(e) {
    this.setState({
      checked: !this.state.checked
    });
    this.props.onChange(e);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({checked: nextProps.isChecked});
  }

  render() {
    return (
    <div>
      <div className="items-form">
        <div className="rows">
          <div className="col-12">
            <Checkbox className="pt-large" checked={this.state.checked} onChange={this.onChange.bind(this)} name={this.props.name} disabled={this.props.disabled}>
              <span className="name_checkbox">{this.props.ten}</span>
            </Checkbox>
          </div>
        </div>
      </div>
      <div className= "items-form" >
        <ShowIf condition={this.state.checked}>
          {this.props.componentFill}
        </ShowIf>
      </div>
    </div>
    )
  }
}

CheckBox.defaultProps = {
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  isChecked: false,
  name:'',
  disabled: false
}

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/CheckBox.jsx